export const COLUMNS = [
  {
    Header: "S.No.",
    Footer: "S.No.",
    accessor: "sNo",
  },

  {
    Header: "Membership",
    Footer: "Membership",
    accessor: "membershipName",
  },

  {
    Header: "Fee",
    Footer: "Fee",
    accessor: "fee",
  },
  {
    Header: "Currency",
    Footer: "Currency",
    accessor: "currency",
  },
  {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },


];
